export enum Sort {
  ASC = 'asc',
  DESC = 'desc'
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female'
}

export enum PlayerStatus {
  HEALTHY = 'healthy',
  INJURED = 'injured'
}

export enum Score {
  BAD = 1,
  POOR = 2,
  FAIR = 3,
  GOOD = 4,
  EXCELLENT = 5
}

export enum Footedness {
  LEFT_FOOTED = 'left',
  RIGHT_FOOTED = 'right'
}

export enum BloodType {
  OPositive = '0+',
  ONegative = '0-',
  APositive = 'A+',
  ANegative = 'A-',
  BPositive = 'B+',
  BNegative = 'B-',
  ABPositive = 'AB+',
  ABNegative = 'AB-',
}

export enum Joint {
  LEFT_ELBOW = 'left_elbow',
  RIGHT_ELBOW = 'right_elbow',
  LEFT_SHOULDER = 'left_shoulder',
  RIGHT_SHOULDER = 'right_shoulder',
  LEFT_GROIN = 'left_groin',
  RIGHT_GROIN = 'right_groin',
  LEFT_HIP = 'left_hip',
  RIGHT_HIP = 'right_hip',
  LEFT_KNEE = 'left_knee',
  RIGHT_KNEE = 'right_knee',
  LEFT_ANKLE = 'left_ankle',
  RIGHT_ANKLE = 'right_ankle',
  LEFT_ACHILLE_TENDON = 'left_achille_tendon',
  RIGHT_ACHILLE_TENDON = 'right_achille_tendon'
}

export enum Muscle {
  LEFT_FOREARM_FRONT = 'left_forearm_front',
  RIGHT_FOREARM_FRONT = 'right_forearm_front',
  LEFT_FOREARM_BACK = 'left_forearm_back',
  RIGHT_FOREARM_BACK = 'right_forearm_back',
  LEFT_UPPERARM_FRONT = 'left_upperarm_front',
  RIGHT_UPPERARM_FRONT = 'right_upperarm_front',
  LEFT_UPPERARM_BACK = 'left_upperarm_back',
  RIGHT_UPPERARM_BACK = 'right_upperarm_back',
  LEFT_BREAST = 'left_breast',
  RIGHT_BREAST = 'right_right',
  LEFT_ABDOMEN = 'left_abdomen',
  RIGHT_ABDOMEN = 'right_abdomen',
  LEFT_UPPER_THIGH_FRONT = 'left_upper_thigh_front',
  RIGHT_UPPER_THIGH_FRONT = 'right_upper_thigh_front',
  LEFT_UPPER_THIGH_BACK = 'left_upper_thigh_back',
  RIGHT_UPPER_THIGH_BACK = 'right_upper_thigh_back',
  LEFT_LOWER_LEG_FRONT = 'left_lower_leg_front',
  RIGHT_LOWER_LEG_FRONT = 'right_lower_leg_front',
  LEFT_LOWER_LEG_BACK = 'left_lower_leg_back',
  RIGHT_LOWER_LEG_BACK = 'right_lower_leg_back'
}

export type PainLocation = Joint | Muscle

export type PainType = 'muscle' | 'joint'

export enum PainLevel {
  MISSING,
  MILD,
  MODERATE,
  SEVERE
}

export enum CoachType {
  TYPE_HEAD = 'head',
  TYPE_ASSISTANT = 'assistant',
  TYPE_GOALKEEPER = 'goalkeeper',
  TYPE_FITNESS = 'fitness',
}
